import ErrorCodeResponseError from './ErrorCodeResponseError';

export default class BasketResponseError extends ErrorCodeResponseError {
    constructor(errorCode: number, message = '') {
        super(errorCode, message);
        this.name = 'BasketResponseError';

        Object.setPrototypeOf(this, BasketResponseError.prototype);
    }
}
